import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GETINTEGRATIONS_REQ } from "../../../actions";
import moment from "moment";

import Paginator from "../../../components/paginator";
import Search from "../../../components/search";

function Integrations({ companyDetails }) {
  const dispatch = useDispatch();
  const integrations = useSelector((state) => state.company.integrations);
  const limit = 6;

  const fetchData = (page) => {
    console.log("DER");
    dispatch(
      GETINTEGRATIONS_REQ({
        page: page,
        limit: limit,
        company_uid: companyDetails.company_uid,
        company_id: companyDetails.company_id,
        keyword,
      })
    );
  };

  const [keyword, setkeyword] = useState("");
  useEffect(() => {
    fetchData(integrations?.current_page || 1);
  }, [keyword]);

  return (
    <div class="h-full mt-3">
      <div class="relative h-full w-full overflow-hidden bg-white rounded-lg shadow px-4">
        <div class="p-2">
          <div class="flow-root">
            <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div class="inline-block min-w-full py-4 align-middle sm:px-6 lg:px-8">
                <div class="mx-auto pb-3 border-b sm:flex sm:items-center sm:justify-between">
                  <h3 class="text-lg font-semibold leading-6 text-gray-900">
                    Integrations
                    <span class="inline-flex items-center rounded-full bg-blue-50 ml-2 px-2 py-1 text-sm font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
                      {integrations?.total_records}
                    </span>
                  </h3>
                  <div class="mt-3 sm:ml-4 sm:mt-0">
                    <div class="flex space-x-2">
                      <Search name="Integrations" onSearch={setkeyword} />
                    </div>
                  </div>
                </div>
                <div className="flex flex-col justify-between min-h-[450px]">
                  <ul class="my-6 grid grid-cols-1 gap-x-6 gap-y-8 lg:grid-cols-3 xl:gap-x-8">
                    {integrations?.data?.map((plugin) => (
                      <li class="overflow-hidden rounded-xl border border-gray-200">
                        <div class="flex items-center gap-x-4 border-b border-gray-900/5  p-6">
                          <img
                            src={plugin.plugin_icon}
                            alt={plugin.plugin_name}
                            class="h-12 w-12 flex-none rounded-lg bg-white object-cover"
                          />
                          <div>
                            <p class="text-base font-medium leading-6 text-gray-900">
                              {plugin.plugin_display_name}
                            </p>
                            <p class="text-xs leading-6 text-gray-600">
                              Installed{" "}
                              {moment(plugin.install_date).format(
                                "MMM DD, YYYY"
                              )}
                            </p>
                          </div>
                        </div>
                        {/* <dl class="-my-3 divide-y divide-gray-100 px-6 py-4 text-sm leading-6">
                          <div class="flex justify-between gap-x-4 py-3">
                            <dt class="text-gray-500">Last used on</dt>
                            <dd class="text-gray-700">
                              <time datetime="2022-12-13">
                                {moment(plugin.updated_at).format(
                                  "MMMM DD, YYYY"
                                )}
                              </time>
                            </dd>
                          </div>
                        </dl> */}
                      </li>
                    ))}
                  </ul>
                  {integrations?.data?.length === 0 && (
                    <div className="w-full h-[350px] flex justify-center items-center text-sm text-gray-500">
                      No Integrations yet.
                    </div>
                  )}

                  <div className=" w-full flex justify-end">
                    <Paginator
                      page={integrations?.current_page || 1}
                      pageLimit={6}
                      totalCount={integrations?.total_records || 0}
                      onPageChange={fetchData}
                      placement="end"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Integrations;
